import itemquickview from "./item-quickview.html";

const quickviewHandler = require('../../../../../components/quickview/quickview-handler')
const dtHandler = require('../../../../../components/dt/dt-handler')
const chart = require('./chart/item-quickview-chart')
const snack = require('./item-snack')
const scrim = require('../../../../../components/scrim/scrim')

/****************ELEMENTS*****************/
var htmlQf = {}
var HTMLwasSelected = false

function HTMLselect(detail) {


      quickviewHandler.HTMLselect(

            'item', //database table name****
            'item-quickview',
            detail.ev.target, //source, for example AC
            itemquickview,
            htmlQf)

      HTMLwasSelected = true


}/**/

export function start(detail) {

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/

const obj = {

      show: { start: (detail) => { chart.clearQuickviewChart(); quickviewHandler.show(detail, htmlQf) } },
      hide: { start: (detail) => { chart.clearQuickviewChart(); quickviewHandler.hide(detail, htmlQf) } },

      getExtraData: { start: (detail) => { getExtraData(detail, htmlQf) } },
      printReport: { start: (detail) => { printReport(detail, htmlQf) } },
}/**/

async function getExtraData(detail, htmlQf) {

      let idItem = detail.idItem || null;
      // 1. Si no hay ID en detail, buscamos en el DOM
      if (!idItem) {
            const container = detail.ev?.target?.nextElementSibling;
            if (!container) return;

            // Verificamos si el chip tiene elementos (está seleccionado)
            const chip = container.querySelector('.chip-cont');

            if (chip && chip.childElementCount > 0) {
                  const otherFieldElem = container.querySelector(".item_id .otherField") || container.querySelector(".purchase_vs_itemId .otherField");
                  const rawFields = otherFieldElem?.getAttribute('otherField');

                  if (rawFields && rawFields !== "undefined" && rawFields !== "null") {
                        try {
                              const parsed = JSON.parse(rawFields);
                              idItem = parsed.item_id;
                        } catch (error) {
                              console.error("Error al parsear otherField en beeStock:", error);
                        }
                  }
            } else {
                  snack.start({ act: 'show', id: 'error', text: 'Select an item' })
            }
      }

      // 2. Si después de las validaciones no hay ID o el chip estaba vacío
      if (!idItem) {
            // Opcional: mostrar un snackbar si el chip estaba vacío
            console.warn("No hay un item seleccionado en el chip.");
            return;
      }

      // 3. Preparar y enviar la petición
      const formData = new FormData();
      formData.append('idItem', idItem);
      formData.append('from', detail.from || '');
      formData.append('idType', detail.idType);

      chart.clearQuickviewChart();

      try {
            const response = await fetch("./server/php/queries/entityFunction/item_behaivor.php", {
                  method: "POST",
                  body: formData,
                  credentials: 'same-origin'
            });

            if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

            const resultados = await response.json();

            // 4. Actualizar la interfaz de beeStock
            if (resultados.data) {
                  quickviewHandler.show(detail, htmlQf)
                  // se agrego un timeout para pintar algunos datos necesarios
                  // para las nuevas funciones que se agregaron relacionadas
                  // al print del reporte de los items
                  setTimeout(() => {
                        const cont = htmlQf.quickviewHTML;
                        cont.setAttribute('data-dbid', idItem)

                        let dataAttributeReport;
                        let dataAttributeHistory;
                        let data;
                        let dataHistory;
                        const btnPrintReport = cont.querySelector('#item-quickview-report-btn')
                        const btnPrintHistory = cont.querySelector('#item-quickview-history-btn')
                        if (detail.from === "sale") {
                              data = {
                                    "click": [
                                          { "dest": "ripple" },
                                          {
                                                "dest": "item",
                                                "elem": "quickview",
                                                "entity": "inventory",
                                                "reportName": "inventory-item-one",
                                                "from": "purchase_vs_item",
                                                "act": "printReport"
                                          }
                                    ]
                              };

                              dataHistory = {
                                    "click": [
                                          { "dest": "ripple" },
                                          {
                                                "dest": "item",
                                                "elem": "quickview",
                                                "entity": "inventory",
                                                "reportName": "inventory-item-history",
                                                "from": "purchase_vs_item",
                                                "act": "printReport"
                                          }
                                    ]
                              };
                        } else {
                              data = {
                                    "click": [
                                          { "dest": "ripple" },
                                          {
                                                "dest": "item",
                                                "elem": "quickview",
                                                "entity": "inventory",
                                                "reportName": "inventory-item-one",
                                                "act": "printReport"
                                          }
                                    ]
                              };

                              dataHistory = {
                                    "click": [
                                          { "dest": "ripple" },
                                          {
                                                "dest": "item",
                                                "elem": "quickview",
                                                "entity": "inventory",
                                                "reportName": "inventory-item-history",
                                                "act": "printReport"
                                          }
                                    ]
                              };
                        }

                        dataAttributeReport = JSON.stringify(data);
                        dataAttributeHistory = JSON.stringify(dataHistory);
                        btnPrintReport.setAttribute('data-detail', dataAttributeReport)
                        btnPrintHistory.setAttribute('data-detail', dataAttributeHistory)

                  }, 500)
                  
                  fillBehaivorCard(resultados.data);
                  fillItemStatus(resultados.data);
                  if (resultados.history) createLastesMovesChart(resultados.history);
                  if (resultados.lastRegister) fillLastesMoves(resultados.lastRegister);
            }

      } catch (err) {
            console.error("Error en obtenerDatosTablaItemBehaivor:", err);
      }
}

function fillBehaivorCard(datos) {

      const columns = [
            { key: 'roi', label: 'ROI', format: 'percent', behavior: true, title: 'roi_title' },
            { key: 'speed', label: 'Speed', format: 'star', behavior: true },
            { key: 'friction', label: 'Sellability', format: 'int', behavior: true },
            { key: 'profit', label: 'Revenue', format: 'star', behavior: true },
            { key: 'return_item', label: 'Return', format: 'percent', behavior: true },
      ];

      const html = dtHandler.dtSimpleFc(datos, columns);

      const title = htmlQf.quickviewHTML.querySelector('#item-title-quickview');
      title.innerHTML = ""
      title.innerHTML = datos[0].name

      const cont = htmlQf.quickviewHTML.querySelector('#item-quickview-behaivor');
      cont.innerHTML = ""
      cont.innerHTML = html

      return
}

function fillItemStatus(datos) {

      const columns = [
            { key: 'available_total', label: 'Total Available', format: 'int', behavior: false },
            { key: 'avg_purchase_price', label: 'AVG Purchase Price', format: 'cash', behavior: false },
            { key: 'avg_selling_price', label: 'AVG Sold Price', format: 'cash', behavior: false },
            { key: 'in_stock_value', label: 'In Stock Value', format: 'cash', behavior: false },
      ];

      const html = dtHandler.dtSimpleFc(datos, columns);

      const cont = htmlQf.quickviewHTML.querySelector('#item-quickview-status');
      cont.innerHTML = ""
      cont.innerHTML = html

      return
}

function fillLastesMoves(datos) {

      const columns = [
            { key: 'last_update', label: 'Month', format: 'date', behavior: false },
            { key: 'inversion', label: 'Inversion', format: 'cash', behavior: false },
            { key: 'speed', label: 'Speed', format: '', behavior: false },
            { key: 'friction', label: 'Sellability', format: '', behavior: false },
            { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: 'roi_title' },
            { key: 'perishable', label: 'Perishable', format: 'percent', behavior: false }
      ];

      const html = dtHandler.dtSimpleFc(datos, columns);

      const cont = htmlQf.quickviewHTML.querySelector('#item-quickview-last-movements');
      cont.innerHTML = ""
      cont.innerHTML = html

      return
}

function createLastesMovesChart(data) {
      chart.createChart(data);
}

function printReport(detail, htmlQf) {
      if (detail.dbid) {
            generateReport(detail.dbid, detail.entity, detail.reportName, detail.from);
            return
      }

      const cont = htmlQf.quickviewHTML;
      const id = cont.getAttribute('data-dbid');
      generateReport(id, detail.entity, detail.reportName, detail.from);
      return

}

function generateReport(dbid, entity, reportName, from) {
      scrim.showLoading()
      const formData = new FormData();
      formData.append('id', dbid);
      formData.append('type', 'print');
      formData.append('entity', entity);
      formData.append('reportName', reportName);
      formData.append('from', from);

      const isPdf = true;

      const controller = new AbortController();
      const timeout = setTimeout(() => { controller.abort() }, 30000);

      let options = {
            method: 'POST',
            body: formData,
            signal: controller.signal,
            credentials: 'same-origin'
      };

      fetch(`./server/php/report/report-pdf.php`, options)
            .then((response) => {
                  clearTimeout(timeout);
                  if (!response.ok) throw new Error("report-pdf");
                  // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

                  return response.blob();
            })
            .then((blob) => {
                  if (isPdf) {
                        // --- LÓGICA PARA PDF ---
                        const pdfBlob = new Blob([blob], { type: "application/pdf" });
                        const fileUrl = URL.createObjectURL(pdfBlob);
                        const newTab = window.open(fileUrl, "_blank");

                        if (newTab) {
                              scrim.hideLoading()
                              newTab.addEventListener('load', () => {
                                    URL.revokeObjectURL(fileUrl);
                              }, { once: true });
                        }
                  } else {
                        scrim.hideLoading()
                        // --- LÓGICA PARA CSV ---
                        // Se define el MIME type para CSV
                        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
                        const fileUrl = URL.createObjectURL(csvBlob);

                        // Creamos un enlace temporal en el DOM
                        const tempLink = document.createElement("a");
                        tempLink.href = fileUrl;

                        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
                        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
                        tempLink.style.display = "none";

                        document.body.appendChild(tempLink);
                        tempLink.click(); // Disparamos la descarga

                        // Limpiamos el DOM y liberamos la memoria
                        document.body.removeChild(tempLink);
                        URL.revokeObjectURL(fileUrl);
                  }
            })

            .catch(error => {
                  scrim.hideLoading()
                  throw error;
            });
}